import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Huerfano} from '@kilobytelab/types';
import {Alumno, Padre} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAlumnosService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** alumnos ***/

  getAlumnosNoBaja(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/nobajas`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getAlumnosAlta(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/alta`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getAlumnosBaja(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/baja`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getAlumnosHuerfanos(): Promise<Huerfano[]> {
    const url = `${this.apiUrl}alumnos/huerfanos`;
    return firstValueFrom(this.http.get<Huerfano[]>(url))
  }
  getMatriculados(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/matriculados`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getMatriculadosAllAccepted(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/matriculados/allaccepted`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getEntradas(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/entradas`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getAlumno(idAlumno: number): Promise<[Alumno, Padre, Padre]> {
    const url = `${this.apiUrl}alumnos/${idAlumno}`;
    return firstValueFrom(this.http.get<[Alumno, Padre, Padre]>(url))
  }
  getAula(aula: number | string): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/alta/${aula}`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getMateriales(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/material`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getCumples(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/cumples`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getComienzos(): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/comienzos`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  updateAutorizacionesAlumno(idAlumno: number, SEPA: boolean, RGPD: boolean, Fotos: boolean, marketing: boolean): Promise<void> {
    const url = `${this.apiUrl}alumnos/update/autorizaciones/${idAlumno}`;
    return firstValueFrom(this.http.post<void>(url, {
      SEPA: SEPA,
      RGPD: RGPD,
      Fotos: Fotos,
      marketing: marketing
    }))
  }
  updateAlumno(datos: Alumno): Promise<any> {
    const url = `${this.apiUrl}alumnos/${datos.id}`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  updateAlumnoAula(alumno: number, aula: number): Promise<void> {
    const url = `${this.apiUrl}alumnos/aula/${aula}/${alumno}`;
    return firstValueFrom(this.http.post<void>(url, {}))
  }
  saveAlumno(datos: {alumno: Alumno, padre1: Padre, padre2: Padre, madre: number}): Promise<number> {
    const url = `${this.apiUrl}alumnos`;
    return firstValueFrom(this.http.post<number>(url, datos))
  }
  checkDuplicates(datos: Alumno): Promise<Alumno[]> {
    const url = `${this.apiUrl}alumnos/duplicates`;
    return firstValueFrom(this.http.post<Alumno[]>(url, datos))
  }
  altaAlumno(datos: Alumno): Promise<any> {
    const url = `${this.apiUrl}alumnos/alta/${datos.id}`;
    return firstValueFrom(this.http.put<any>(url, {aula: datos.aula}))
  }
  savePadre2Alumno(idAlumno: number, numero: number, padre: Padre): Promise<number> {
    const url = `${this.apiUrl}alumnos/addpadre/${idAlumno}/${numero}`;
    return firstValueFrom(this.http.put<number>(url, padre))
  }
  updateAlumnoEducadora(datos: Alumno, id: number): Promise<any> {
    const url = `${this.apiUrl}alumnos/update/${id}`;
    return firstValueFrom(this.http.put<any>(url, {data: datos}))
  }
  eliminarAlumno(idAlumno: number): Promise<any> {
    const url = `${this.apiUrl}alumnos/${idAlumno}`;
    return firstValueFrom(this.http.delete<any>(url))
  }
  eliminarPadreFromAlumno(idAlumno: number, numero: number): Promise<any> {
    const url = `${this.apiUrl}alumnos/padre/${idAlumno}/${numero}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
